import React from 'react'

/**
 * Progress export CSV. Datanya diambil per halaman, jadi prosesnya bisa lama
 * kalau pendaftarnya banyak -- user perlu tahu sudah sampai mana dan punya
 * jalan keluar kalau tidak mau menunggu.
 *
 * `total` masih 0 selama halaman pertama belum balik, karena jumlah totalnya
 * memang baru diketahui dari response itu.
 */
const ExportProgressModal = ({ open, loaded = 0, total = 0, onCancel }) => {
  const isCounting = total <= 0
  const percent = isCounting ? 0 : Math.min(100, Math.round((loaded / total) * 100))

  return (
    <div className={`modal ${open ? 'modal-open' : ''}`}>
      <div className="modal-box relative">
        <h1 className="text-xl font-semibold">Menyiapkan Export CSV</h1>
        <p className="mt-2 text-sm text-[#838489]">
          Data diambil per halaman. Jangan tutup halaman ini sampai selesai.
        </p>

        <div className="my-6">
          {isCounting ? (
            <progress className="progress progress-primary w-full" />
          ) : (
            <progress
              className="progress progress-primary w-full"
              value={loaded}
              max={total}
            />
          )}
          <div className="flex justify-between items-center mt-2 text-sm">
            <span className="text-[#838489]">
              {isCounting
                ? 'Menghitung total data...'
                : `${loaded} dari ${total} anggota`}
            </span>
            {!isCounting && <span className="font-semibold">{percent}%</span>}
          </div>
        </div>

        <div className="flex justify-end">
          <button type="button" className="btn btn-outline" onClick={onCancel}>
            Batalkan
          </button>
        </div>
      </div>
    </div>
  )
}

export default ExportProgressModal
